import { http } from "../http";

export const getAllServiceBookings = async ({ queryKey }: any) => {
  return await http.get("booking", {
    params: {
      ...queryKey[1],
    },
  });
};

export const getBookingById = async ({ queryKey }: any) => {
  return await http.get(`booking/${queryKey[1]}`);
};

export const getbookingFeed = async ({ queryKey }: any) => {
  return await http.get("booking-feed", {
    params: {
      ...queryKey[1],
    },
  });
};

export const assignVolunteer = async ({ id, data }: any) => {
  return await http.patch(`booking/${id}/assign-volunteer`, data);
};

export const createVolunteer = async (data: any) => {
  return await http.post("/volunteer", data);
};

export const getVolunteers = async ({ queryKey }: any) => {
  return await http.get("/volunteer", {
    params: {
      ...queryKey[1],
    },
  });
};

export const getVolunteerById = async ({ queryKey }: any) => {
  return await http.get(`/volunteer/${queryKey[1]}`);
};

export const getVolunteerActivity = async ({ queryKey }: any) => {
  return await http.get(`/volunteer/activity/${queryKey[1]}`);
};

export const getVolunteerBookings = async ({ queryKey }: any) => {
  return await http.get(`/volunteer/bookings/${queryKey[1]}`);
};

export const updateVolunteerById = async ({ id, data }: any) => {
  return await http.patch(`/volunteer/${id}`, data);
};

export const updateVolunteerStatus = async ({ id, data }: any) => {
  return await http.patch(`/volunteer/update/status/${id}`, data);
};

export const updateVolunteerServices = async ({ id, data }: any) => {
  return await http.patch(`/volunteer/update/services/${id}`, data);
};

export const updateVolunteerLocation = async ({ id, data }: any) => {
  return await http.patch(`/volunteer/update/locations/${id}`, data);
};

export const editLocation = async ({ volunteerId, locationId, data }: any) => {
  return await http.patch(
    `volunteer/${volunteerId}/locations/${locationId}`,
    data
  );
};

export const deleteLocation = async ({ volunteerId, locationId }: any) => {
  return await http.delete(`volunteer/${volunteerId}/locations/${locationId}`);
};

export const updateVolunteerKyc = async ({ id, data }: any) => {
  return await http.patch(`/volunteer/update/kyc/${id}`, data);
};

export const updateVolunteerDocumenation = async ({ id, data }: any) => {
  return await http.patch(`/volunteer/update/documentation/${id}`, data);
};

export const getFeed = async () => {
  return await http.get("/feed");
};

export const postFeed = async (data: any) => {
  return await http.post("/feed", data);
};

export const deleteFeed = async ({ id }: any) => {
  return await http.delete(`/feed/${id}`);
};

export const postServiceCategory = async (data: any) => {
  return await http.post("/service-category", data);
};

export const getServiceCategory = async () => {
  return await http.get("/service-category");
};

export const getServiceCategoryById = async ({ queryKey }: any) => {
  return await http.get(`/service-category/${queryKey[1]}`, {
    params: { includeInactive: true },
  });
};

export const updateServiceCategory = async ({ id, data }: any) => {
  return await http.patch(`/service-category/${id}`, data);
};

export const postServiceType = async (data: any) => {
  return await http.post("/service-type", data);
};

export const updateServiceType = async ({ id, data }: any) => {
  return await http.patch(`/service-type/${id}`, data);
};

export const setServiceTypeStatus = async ({ id, isActive }: any) => {
  return await http.patch(`/service-type/${id}/status`, { isActive });
};

export const getService = async ({ queryKey }: any) => {
  return await http.get("/service", {
    params: {
      ...queryKey[1],
      includeInactive: true,
    },
  });
};

export const getServiceName = async () => {
  return await http.get("/service-category/name");
};

// ---- Branches ----
export const createBranch = async (data: any) => {
  return await http.post("/branch", data);
};

export const getBranches = async ({ queryKey }: any) => {
  return await http.get("/branch", { params: { ...queryKey[1] } });
};

export const getBranchNames = async () => {
  return await http.get("/branch/name");
};

export const updateBranch = async ({ id, data }: any) => {
  return await http.patch(`/branch/${id}`, data);
};

export const deleteBranch = async ({ id }: any) => {
  return await http.delete(`/branch/${id}`);
};

// ---- Warehouse Locations ----
export const createWarehouseLocation = async (data: any) => {
  return await http.post("/warehouse-location", data);
};

export const getWarehouseLocations = async ({ queryKey }: any) => {
  return await http.get("/warehouse-location", {
    params: { ...queryKey[1] },
  });
};

export const updateWarehouseLocation = async ({ id, data }: any) => {
  return await http.patch(`/warehouse-location/${id}`, data);
};

export const deleteWarehouseLocation = async ({ id }: any) => {
  return await http.delete(`/warehouse-location/${id}`);
};

export const getServiceById = async ({ queryKey }: any) => {
  return await http.get(`/service/${queryKey[1]}`, {
    params: { includeInactive: true },
  });
};

export const postService = async (data: any) => {
  return await http.post("/service", data);
};

export const updateService = async ({ id, data }: any) => {
  return await http.patch(`/service/${id}`, data);
};

export const sortServices = async (body: any) => {
  return http.patch(`service/sort-order`, body);
};

export const deleteService = async (id: any) => {
  return await http.delete(`/service/${id}`);
};

export const postSubService = async ({ id, data }: any) => {
  return await http.patch(`/service/types/${id}`, data);
};

export const getLockers = async ({ queryKey }: any) => {
  return await http.get("/locker", {
    params: {
      ...queryKey[1],
    },
  });
};

export const createLocker = async (data: any) => {
  return await http.post("/locker", data);
};

export const updateLocker = async ({ id, data }: any) => {
  return await http.patch(`/locker/${id}`, data);
};

export const deleteLocker = async (id: any) => {
  return await http.delete(`/locker/${id}`);
};

export const getEmergencyAlert = async ({ queryKey }: any) => {
  return await http.get(`/emergency-alerts`, {
    params: {
      ...queryKey[1],
    },
  });
};

export const updateRole = ({ roleId, data }: any) => {
  return http.patch(`/volunteer/update/role/${roleId}`, data);
};

export const getNearestVolunteer = ({ queryKey }: any) => {
  return http.get(`/booking/nearest-users/${queryKey[1]}`);
};

export const getEmergencyAlertById = async ({ queryKey }: any) => {
  return await http.get(`/emergency-alerts/${queryKey[1]}`);
};

export const updateEmergencyStatus = async ({ id, data }: any) => {
  return await http.patch(`/emergency-alerts/${id}/status`, data);
};

export const getDashboardStats = async () => {
  return await http.get("/dashboard/stats");
};

// ---- RBAC ----
export const getMyPermissions = async () => {
  return await http.get("/rbac/my-permissions");
};

export const getPermissionMatrix = async () => {
  return await http.get("/rbac/matrix");
};

export const getAllPermissions = async () => {
  return await http.get("/rbac/permissions");
};

export const updateRolePermissions = async ({ role, permissions }: any) => {
  return await http.patch(`/rbac/matrix/${role}`, { permissions });
};

// ---- Manage Admin Users (Super Admin) ----
export const createAdmin = async (data: any) => {
  return await http.post("/staff/admins", data);
};

export const getAdmins = async ({ queryKey }: any) => {
  return await http.get("/staff/admins", { params: { ...queryKey[1] } });
};

export const getAdminById = async ({ queryKey }: any) => {
  return await http.get(`/staff/admins/${queryKey[1]}`);
};

export const updateAdmin = async ({ id, data }: any) => {
  return await http.patch(`/staff/admins/${id}`, data);
};

export const setAdminStatus = async ({ id, isActive }: any) => {
  return await http.patch(`/staff/admins/${id}/status`, { isActive });
};

// ---- Manage Managers ----
export const createManager = async (data: any) => {
  return await http.post("/staff/managers", data);
};

export const getManagers = async ({ queryKey }: any) => {
  return await http.get("/staff/managers", { params: { ...queryKey[1] } });
};

export const updateManager = async ({ id, data }: any) => {
  return await http.patch(`/staff/managers/${id}`, data);
};

export const setManagerStatus = async ({ id, isActive }: any) => {
  return await http.patch(`/staff/managers/${id}/status`, { isActive });
};

export const getAvailableAssociates = async ({ queryKey }: any) => {
  return await http.get(`/staff/managers/${queryKey[1]}/available-associates`);
};

export const assignAssociates = async ({ id, associateIds }: any) => {
  return await http.patch(`/staff/managers/${id}/associates`, { associateIds });
};

// ---- Unified Users hub ----
export const createStaffUser = async (data: any) => {
  return await http.post("/staff/users", data);
};

export const getStaffUsers = async ({ queryKey }: any) => {
  return await http.get("/staff/users", { params: { ...queryKey[1] } });
};

export const getStaffAvailable = async ({ queryKey }: any) => {
  const { id, childType } = queryKey[1] || {};
  return await http.get(`/staff/users/${id}/available`, {
    params: { childType },
  });
};

export const assignStaffChildren = async ({ id, childType, childIds }: any) => {
  return await http.patch(`/staff/users/${id}/assign`, { childType, childIds });
};

export const setStaffUserStatus = async ({ id, isActive }: any) => {
  return await http.patch(`/staff/users/${id}/status`, { isActive });
};

export const updateStaffUser = async ({ id, data }: any) => {
  return await http.patch(`/staff/users/${id}`, data);
};

// Booking role assignment. Send JSON null (not "") to clear a slot — the
// server DTO uses @ValidateIf(v !== null), so "" would fail validation.
export const assignBookingRoles = async ({ id, data }: any) => {
  return await http.patch(`booking/${id}/assign`, data);
};

export const updateBookingStatus = async ({ id, data }: any) => {
  return await http.patch(`booking/${id}/booking-status`, data);
};

// Support & cancellation requests. Pass bookingId in the query params to scope
// them to one booking — the filter is applied server-side so count matches rows.
export const getSupportRequests = async ({ queryKey }: any) => {
  return await http.get("support-requests", { params: { ...queryKey[1] } });
};

export const getCancellationRequests = async ({ queryKey }: any) => {
  return await http.get("cancellation-requests", { params: { ...queryKey[1] } });
};

export const updateSupportRequestStatus = async ({ id, data }: any) => {
  return await http.patch(`support-requests/${id}/status`, data);
};

export const updateCancellationRequestStatus = async ({ id, data }: any) => {
  return await http.patch(`cancellation-requests/${id}/status`, data);
};

// Assign a contractor to one additional-service item (travel / medical /
// shopping assistance). Independent of the booking-level contractor.
export const assignAdditionalServicePartner = async ({ id, data }: any) => {
  return await http.patch(`booking/${id}/additional-service/assign`, data);
};

// Quotation builder. Line items live on the booking as quotation.quotations[];
// quotation-feed is the read shape both this builder and the customer app use,
// so what an admin sees here is what the customer will see once it is sent.
export const getQuotation = async ({ queryKey }: any) => {
  return await http.get(`quotation/${queryKey[1]}/quotation-feed`);
};

export const saveQuotation = async ({ id, data }: any) => {
  return await http.patch(`quotation/${id}`, data);
};

// responseType blob is required — the default JSON transform corrupts the
// binary and the saved file will not open.
export const downloadQuotationPdf = async (bookingId: string) => {
  const response = await http.get(`quotation/${bookingId}/pdf`, {
    responseType: "blob",
  });
  return response.data as Blob;
};
